<template>

	<!--
		This page needs to be updated to use the organization_roles table if it is to be used
	-->

	<HeroLayout v-model="showContactUs">
		<form class="flex flex-col w-full">
			<p class="text-center text-xl font-semibold text-heading">Step</p>
			<StepIndicator class="mt-4" :current_step="4" :total_steps="4" />

			<p class="registration-title mt-21">Tell us about yourself</p>
			<p class="registration-subtitle mt-1 mb-10">
				Please select the option that best describes your role.
			</p>

			<InputText
				label="Organization title*"
				type="text"
				placeholder="Enter your organization job title"
				v-model="organization_title"
				error-field="user_organization.organization_title"
				:errors="error"
			/>

			<Combobox
				id="combo_add_role"
				v-model="organization_role"
				class="flex flex-col mt-4"
				:items="Array.from(organization_roles.values())"
				:title="'Organization role*'"
				:placeholder="'Select option'"
				:errors="error"
				error-field="user_organization.organization_role"
				:readonly="true"
			/>
		</form>

		<SubmitButton
			class="ml-auto mt-10"
			label="Next"
			:loading="isLoading"
			@click="updateUserOrganization"
		/>
		<ValidationError :errors="error" :field="null" />
	</HeroLayout>
</template>

<script setup lang="js">
import { onMounted, ref } from 'vue'
import InputText from '@/components/Forms/InputText.vue'
import ValidationError from '@/components/Forms/InputError.vue'
import StepIndicator from '@/components/Registration/StepIndicator.vue'
import Combobox from '@/components/Forms/Combobox.vue'
import { userOrganizationsApi } from '@/api/Organizations/UserOrganizationsApi.js'
import router from '@/router/router.js'
import { useSignupStore } from '@/stores/signupStore.js'
import { useAuthStore } from '@/stores/authStore.js'
import HeroLayout from '@/layouts/HeroLayout.vue'
import SubmitButton from '@/components/Forms/Buttons/SubmitButton.vue'

const signupStore = useSignupStore()
const isLoading = ref(false)
const error = ref(null)
const organization_roles = new Map([
	['provider', 'Provider'],
	['qia', 'Quality Improvement Advisor (QIA)'],
	['viewer', 'CMS Viewer'],
	['admin', 'Administrator']
])
const organization_role = ref('')
const organization_title = ref('')
const user_organization = ref(null)
const showContactUs = ref(false)

onMounted(() =>
{
	getUserOrganization()
})

function getUserOrganization()
{
	user_organization.value = signupStore.getUserOrganization
}

function findRoleKeyByValue(targetValue)
{
	for (const [key, value] of organization_roles.entries())
	{
		if (value === targetValue)
		{
			return key
		}
	}
	return undefined
}

function updateUserOrganization()
{
	error.value = null
	isLoading.value = true

	if (user_organization.value)
	{
		user_organization.value.organization_role = findRoleKeyByValue(organization_role.value)
		user_organization.value.organization_title = organization_title.value
		signupStore.setUserOrganization(JSON.stringify(user_organization.value))

		userOrganizationsApi.update(
			{ user_organization: user_organization.value },
			() =>
			{
				isLoading.value = false
				signupStore.setUserOrganization(null)
				router.push({ name: 'auth.signup-success' })
			},
			(e) =>
			{
				isLoading.value = false
				error.value = e.showErrorBanner()
			}
		)
	}
	else
	{
		const user = useAuthStore().getAuth?.user()

		userOrganizationsApi.createRoleOnly(
			user.id,
			findRoleKeyByValue(organization_role.value),
			organization_title.value,
			() =>
			{
				isLoading.value = false
				router.push({ name: 'auth.signup-success' })
			},
			(e) =>
			{
				isLoading.value = false
				error.value = e.showErrorBanner()
			}
		)
	}
}
</script>
